<template>
  <div class="component-testeditorstages">
    <!-- Debug info -->
    <!-- v-alert v-if="!test || test.length === 0" type="error" class="mb-2">
      <strong>Debug TestEditorStages:</strong> Nessun test ricevuto. test.length = {{ test ? test.length : 'null' }}
    </v-alert>

    <v-alert v-else type="success" class="mb-2">
      <strong>Debug TestEditorStages:</strong> Test ricevuto con {{ test.length }} stage
    </v-alert -->

    <v-stepper class="elevation-0"
      v-if="status && status.currentStage && test && test.length > 0"
      v-model="status.currentStage">
      <v-stepper-header>
        <template v-for="(stage, index) of test">
          <v-stepper-step
            :key="`step-${index}`"
            :step="index+1"
            :complete="isStageComplete(stage)"
            :color="stageColor(stage)"
            :class="{
              'stage-selectable': mode === 'edit',
              'stage-selected': mode === 'edit' && selectedStageIndex === index && selectedQuestionIndex === null
            }"
            @click="mode === 'edit' ? onStageClick(index) : null">
            {{ stage.title }}
          </v-stepper-step>

          <v-divider
            v-if="index < test.length - 1"
            :key="`divider-${index}`"></v-divider>
        </template>
      </v-stepper-header>
    </v-stepper>

  </div>
</template>

<script>
export default {
  name: 'TestEditorStages',

  props: ['value', 'test', 'mode', 'selectedStageIndex', 'selectedQuestionIndex'],

  data: () => ({
    status: null,
  }),

  created() {
    this.status = this.value;
  },

  watch: {
    value(newValue) {
      this.status = newValue;
    },

    status(newValue) {
      this.$emit('input', newValue);
    },
  },

  methods: {
    isStageComplete(stage) {
      return this.status
        && 'stages' in this.status
        && stage.name in this.status.stages
        && 'complete' in this.status.stages[stage.name]
        ? this.status.stages[stage.name].complete
        : false;
    },

    stageColor(stage) {
      return this.isStageComplete(stage) ? 'success' : 'primary';
    },

    onStageClick(stageIndex) {
      if (this.mode === 'edit') {
        this.$emit('stage-selected', stageIndex);
      }
      // In modalità preview, non permettere la navigazione tra stage
      // La navigazione avviene solo tramite i pulsanti "Continua" e "Ricomincia"
    },
  },
};
</script>

<style scoped>
.component-testeditorstages .v-stepper__label {
  text-align: center !important;
}

.stage-selectable .v-stepper__step {
  cursor: pointer;
  transition: background-color 0.2s;
}

.stage-selectable .v-stepper__step:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Evidenziazione dello step selezionato */
.stage-selected {
  background-color: rgba(25, 118, 210, 0.08) !important;
  border-radius: 4px !important;
  margin: 0 2px !important;
  z-index: 2 !important;
  position: relative !important;
}

.stage-selected .v-stepper__step__step {
  background-color: #1976d2 !important;
  color: white !important;
}

.stage-selected .v-stepper__label {
  color: #1976d2 !important;
  font-weight: 600 !important;
}

/* Migliora la separazione tra gli step */
.v-stepper__step {
  margin: 0 1px !important;
  position: relative !important;
  flex-shrink: 0 !important; /* Impedisce il restringimento */
}

/* Header scrollabile orizzontalmente con selettori più specifici */
.component-testeditorstages .v-stepper .v-stepper__header {
  height: 77px !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  white-space: nowrap !important;
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

/* Impedisce il wrapping del testo nelle etichette */
.component-testeditorstages .v-stepper__label {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 150px !important;
}

/* Forza i step a rimanere sulla stessa riga */
.component-testeditorstages .v-stepper__step {
  flex-shrink: 0 !important;
  min-width: auto !important;
}
</style>
